export default "__VITE_ASSET__CBA_SdLq__"